{
	"bg" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"cs" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc Al",
		"audibel_intrigue" : "Zaujměte AI",
		"banner" : "Kompatibilita s chytrým telefonem",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "člen rodiny, přítel nebo pečovatel",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Prosím {0} o kompatibilitu seznamu.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Pokračuj",
		"data_removed_body" : "Všechna data která jste shromáždil budou odstraněna. To zahrnuje i vaše sluchadlo a aktivní data.",
		"delete_account_header" : "Účet {0} zrušen",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Stáhněte {0} aplikaci",
		"email_input" : "Vložte emailovou adresu",
		"email_to_confirm_deletion_body" : "Obdržíte mail žádající vás o potvrzení zrušení vašeho {0} účtu. Použijte instrukce ke zrušení účtu.",
		"header" : "Já jsem...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "Můj Audibel",
		"my_phantom" : "Můj Phantom",
		"my_sound_gear" : "Můj SoundGear",
		"my_starkey" : "Můj Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Lituji, vaše zařízení nebylo rozpoznáno a není podporováno.",
		"not_tested" : "Vaše zařízení není plně otestováno. V mezidobí můžete stahnout aplikaci, protože mnoho vlastností bude fungovat bez nutnosti streamování.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Vaše zařízení je podporováno, ačkoliv operační systém (OS) potřebuje update.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Bohužel osobní počítač není podporován.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Vaše zařízení je podporováno, ačkoliv streaming není možný.",
		"supported" : "Vaše zařízení je podporováno!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Vaše zařízení je podporováno a schopno hands-free konverzace s 2cestným audiem.",
		"tap_here" : "ťukni zde",
		"test" : "toto je jen test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Abyste zrušili váš {0} účet, vložte emailovou adresu a klepněte na \"Pokračování\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "nošení {0} sluchadla"
	},
	"da" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"de" : {
		"afflelou_incognito_edge_ai" : "Inkognito Edge AI",
		"aid_type_form_caregiver" : "Ich bin ein Familienmitglied, Freund oder eine Vertrauensperson",
		"aid_type_form_header" : "Ich trage ...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone-Kompatibilität",
		"banner_computer_support" : "Computerunterstützung für Hörsysteme.",
		"banner_device_compatibility" : "Gerätekompatibilität",
		"banner_download_page" : "Download app",
		"caregiver" : "ein Familienmitglied, ein Freund oder eine Vertrauensperson",
		"caregiver_afton" : "Ich bin ein Familienmitglied, eine befreundete Person oder eine Pflegeperson.",
		"compatibility_list" : "Eine Kompatibilitätsliste finden Sie unter {0}.",
		"compatibility_link_text_mac" : "Liste der Hörsysteme \"Made for iPhone\"",
		"compatibility_link_text_windows" : "Überprüfen Sie, ob Ihr Windows 11-PC Bluetooth Low Energy Audio unterstützt.",
		"compatiblity_statement_pc" : "Bitte beachten Sie Folgendes für die Computerunterstützung von Hörsystemen:",
		"continue_button" : "Fortfahren",
		"data_removed_body" : "Alle Daten, deren Speicherung Sie zuvor zugestimmt haben, werden gelöscht. Dazu gehören Ihre Hörsystem- und Aktivitätsdaten.",
		"delete_account_header" : "Konto {0} löschen",
		"device_may_support_two_way_audio_message" : "Um mehr über die Streaming-Funktionen für Ihr spezifisches Gerät zu erfahren,",
		"device_may_support_two_way_audio_message_tap_here" : "tippen Sie hier.",
		"download_app" : "Laden Sie die {0}-app herunter",
		"email_input" : "E-Mail-Adresse eingeben",
		"email_to_confirm_deletion_body" : "Sie erhalten dann eine E-Mail, in der Sie aufgefordert werden, die Löschung Ihres {0}-Kontos zu bestätigen. Folgen Sie den Anweisungen, um Ihr Konto zu löschen.",
		"header" : "Ich bin...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Ihr Computer unterstützt kein Streamen von Signalen an die Hörsysteme.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Es kann jedoch vorkommen, dass die Leistung aufgrund des Betriebssystems (OS) Ihres Geräts eingeschränkt ist. Weitere Informationen zu empfohlenen Geräten finden Sie unter",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Für die für {0} eingegebene E-Mail-Adresse sind keine Accountdaten vorhanden.",
		"not_recognized" : "Ihr Smartphone wird leider nicht erkannt und daher nicht unterstützt.",
		"not_tested" : "Ihr Smartphone ist (noch) nicht vollständig getestet. In der Zwischenzeit können Sie die App herunterladen, da viele Funktionen auch ohne Streaming funktionieren.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "oder",
		"os_updated_required" : "Ihr Smartphone wird unterstützt, jedoch benötigt dieses Gerät ein Update des Betriebssystems.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Es tut uns leid, persönliche Computer werden leider nicht unterstützt.",
		"recommended_devices_learn_more_message" : "Weitere Informationen zu geeigneten Geräten,",
		"sent_check_email" : "Prüfen Sie Ihre E-Mail",
		"sent_confirmation" : "Wenn ein Konto für die eingegebene Adresse existiert, wurde eine E-Mail gesendet.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Ihr Smartphone unterstützt die App, die Technologie Ihres Smartphones ermöglicht jedoch kein Streaming.",
		"supported" : "Ihr Gerät wird unterstützt!",
		"supported_cannot_update_os" : "Es besteht jedoch die Möglichkeit, dass die Leistung aufgrund des Betriebssystems (OS) Ihres Geräts eingeschränkt ist.",
		"supported_two_way" : "Ihr Gerät unterstützt Freisprechgespräche mit 2-Wege-Audio!",
		"tap_here" : "hier tippen",
		"test" : "dies ist ein Test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Um Ihr {0} Konto zu löschen, geben Sie Ihre E-Mail-Adresse ein und wählen Sie \"Weiter\".",
		"unable_to_confirm_phone_support" : "Wir können nicht gewährleisten, dass Ihr Gerät vollständig unterstützt wird. Sie können die App herunterladen, aber es kann zu Leistungseinschränkungen kommen.",
		"wearing_hearing_aids" : "Träger von {0} Hörsystemen"
	},
	"el" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Είμαι μέλος της οικογένειας, φίλος ή φροντιστής",
		"aid_type_form_header" : "φοράω…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Συμβατότητα smartphone",
		"banner_computer_support" : "Υποστήριξη υπολογιστή για ακουστικά βαρηκοΐας.",
		"banner_device_compatibility" : "Συμβατότητα συσκευής",
		"banner_download_page" : "Download app",
		"caregiver" : "μέλος της οικογένειας, φίλος ή φροντιστής",
		"caregiver_afton" : "Είμαι μέλος της οικογένειας, φίλος ή φροντιστής.",
		"compatibility_list" : "Παρακαλούμε {0} για μια λίστα συμβατότητας.",
		"compatibility_link_text_mac" : "Λίστα ακουστικών συμβατά με iPhone",
		"compatibility_link_text_windows" : "Ελέγξτε εάν ο υπολογιστής σας με Windows 11 υποστηρίζει ήχο χαμηλής κατανάλωσης Bluetooth",
		"compatiblity_statement_pc" : "Ανατρέξτε στα παρακάτω για υποστήριξη υπολογιστή ακουστικών βαρηκοΐας:",
		"continue_button" : "Συνέχεια",
		"data_removed_body" : "Όλα τα δεδομένα που είχατε προηγουμένως συναινέσει να αποθηκευτούν θα αφαιρεθούν. Αυτό περιλαμβάνει τα δεδομένα του ακουστικού και δραστηριότητάς σας.",
		"delete_account_header" : "Διαγραφή λογαριασμού {0}",
		"device_may_support_two_way_audio_message" : "Για να μάθετε περισσότερα σχετικά με τις δυνατότητες ροής για τη συγκεκριμένη συσκευή σας,",
		"device_may_support_two_way_audio_message_tap_here" : "πατήστε εδώ.",
		"download_app" : "Κατεβάστε την εφαρμογή {0}",
		"email_input" : "Εισάγετε ηλεκτρονική διεύθυνση",
		"email_to_confirm_deletion_body" : "Θα λάβετε ένα email που θα σας ζητά να επιβεβαιώσετε τη διαγραφή του λογαριασμού σας {0}. Ακολουθήστε τις οδηγίες για να τον διαγράψετε",
		"header" : "Είμαι...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Ο υπολογιστής σας δεν υποστηρίζεται για ροή στα ακουστικά μας.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Ωστόσο, ενδέχεται να αντιμετωπίσετε περιορισμένη απόδοση λόγω του λειτουργικού συστήματος (OS) της συσκευής σας. Για να μάθετε περισσότερα σχετικά με τις προτεινόμενες συσκευές,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Δεν υπάρχουν πληροφορίες λογαριασμού για τη διεύθυνση ηλεκτρονικού ταχυδρομείου που καταχωρίσατε για το {0}.",
		"not_recognized" : "Λυπούμαστε, η συσκευή σας δεν αναγνωρίζεται και δεν υποστηρίζεται.",
		"not_tested" : "Η συσκευή σας δεν έχει ελεγχθεί πλήρως. Στο μεταξύ, μπορείτε να κάνετε λήψη της εφαρμογής, καθώς πολλές λειτουργίες λειτουργούν χωρίς να χρειάζεται να κάνετε ροή.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "ή",
		"os_updated_required" : "Η συσκευή σας υποστηρίζεται, ωστόσο απαιτείται ενημέρωση του λειτουργικού συστήματος (OS).",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Λυπούμαστε, οι προσωπικοί υπολογιστές δεν υποστηρίζονται.",
		"recommended_devices_learn_more_message" : "Για να μάθετε περισσότερα σχετικά με τις προτεινόμενες συσκευές,",
		"sent_check_email" : "Ελέγξτε το email σας",
		"sent_confirmation" : "Εάν υπάρχει λογαριασμός για τη διεύθυνση που καταχωρίσατε, έχει σταλεί email.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Η συσκευή σας υποστηρίζεται, ωστόσο η ροή δεν είναι διαθέσιμη.",
		"supported" : "Η συσκευή σας υποστηρίζεται!",
		"supported_cannot_update_os" : "Ωστόσο, ενδέχεται να αντιμετωπίσετε περιορισμένη απόδοση λόγω του λειτουργικού συστήματος (OS) της συσκευής σας",
		"supported_two_way" : "Η συσκευή σας υποστηρίζεται και έχει δυνατότητα συνομιλιών hands-free με 2-Way Audio!",
		"tap_here" : "πατήστε εδώ",
		"test" : "υτό είναι ένα τεστ",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Για να διαγράψετε τον λογαριασμό σας {0}, εισαγάγετε τη διεύθυνση email σας και επιλέξτε \"Συνέχεια\".",
		"unable_to_confirm_phone_support" : "Δεν μπορούμε να επιβεβαιώσουμε εάν η συσκευή σας υποστηρίζεται πλήρως. Μπορείτε να κάνετε λήψη της εφαρμογής, αλλά ενδέχεται να έχετε περιορισμένη απόδοση.",
		"wearing_hearing_aids" : "φορώντας {0} ακουστικά βαρηκοΐας"
	},
	"en" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"en-ca" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"en-gb" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"es" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Soy un miembro de la familia, amigo o cuidador",
		"aid_type_form_header" : "Estoy usando...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Compatibilidad teléf inteligente",
		"banner_computer_support" : "Soporte informático para audífonos.",
		"banner_device_compatibility" : "Compatibilidad de dispositivos",
		"banner_download_page" : "Download app",
		"caregiver" : "un miembro de la familia, amigo o cuidador",
		"caregiver_afton" : "Soy familiar, amigo o cuidador.",
		"compatibility_list" : "Por favor {0} para una lista de compatibilidad.",
		"compatibility_link_text_mac" : "Lista de audífonos Hechos para iPhone",
		"compatibility_link_text_windows" : "Comprueba si tu PC con Windows 11 es compatible con Bluetooth de Baja Energía de Audio",
		"compatiblity_statement_pc" : "Consulte a continuación el soporte informático de los audífonos:",
		"continue_button" : "Continuar",
		"data_removed_body" : "Se eliminarán todos los datos que haya consentido almacenar previamente. Esto incluye su audífono y los datos de actividad.",
		"delete_account_header" : "Eliminar cuenta {0}",
		"device_may_support_two_way_audio_message" : "Para obtener más información sobre las capacidades de transmisión de tu dispositivo específico,",
		"device_may_support_two_way_audio_message_tap_here" : "toque aquí.",
		"download_app" : "Descargue la aplicación {0}",
		"email_input" : "Ingresar correo electrónico",
		"email_to_confirm_deletion_body" : "Recibirás un correo electrónico pidiéndote que confirmes la eliminación de tu cuenta {0}. Siga las instrucciones para eliminar su cuenta.",
		"header" : "Yo soy...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Su computadora no es compatible con la transmisión a nuestros audífonos.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Sin embargo, es posible que experimentes un rendimiento limitado debido al sistema operativo (SO) de tu dispositivo. Para obtener más información sobre los dispositivos recomendados,",
		"my_audibel" : "Mi Audible",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No existe información de cuenta para la dirección de correo electrónico ingresada para {0}.",
		"not_recognized" : "Lo sentimos, su dispositivo no es reconocido y no es compatible.",
		"not_tested" : "Tu dispositivo no está totalmente probado. Mientras tanto, puedes descargar la aplicación, ya que muchas funciones funcionan sin necesidad de hacer transmisión.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "o",
		"os_updated_required" : "Tu dispositivo es compatible, pero necesita una actualización del sistema operativo (OS).",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Lo sentimos, no se admiten computadores personales.",
		"recommended_devices_learn_more_message" : "Para saber más sobre los dispositivos recomendados,",
		"sent_check_email" : "Consultar su correo electrónico",
		"sent_confirmation" : "Si existe una cuenta para la dirección ingresada, se ha enviado un correo electrónico.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Su dispositivo es compatible, pero la transmisión no está disponible.",
		"supported" : "¡Tu dispositivo es compatible!",
		"supported_cannot_update_os" : "Sin embargo, es posible que experimentes un rendimiento limitado debido al sistema operativo (SO) de tu dispositivo.",
		"supported_two_way" : "¡Tu dispositivo es compatible y capaz de mantener conversaciones manos libres con audio de 2 Vías!",
		"tap_here" : "toque aquí",
		"test" : "esto es una prueba",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Para eliminar tu cuenta {0}, introduce tu dirección de correo electrónico y selecciona «Continuar».",
		"unable_to_confirm_phone_support" : "No podemos confirmar si su dispositivo es totalmente compatible. Puedes descargar la aplicación, pero es posible que el rendimiento sea limitado.",
		"wearing_hearing_aids" : "usando {0} audífonos"
	},
	"fi" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Olen perheenjäsen, ystävä tai läheinen",
		"aid_type_form_header" : "Minulla on...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Älypuhelin yhteensopivuus",
		"banner_computer_support" : "Tietokoneen tuki kuulokojeille.",
		"banner_device_compatibility" : "Laitteiden yhteensopivuus",
		"banner_download_page" : "Lataa sovellus",
		"caregiver" : "perheenjäsen, ystävä tai läheinen",
		"caregiver_afton" : "Olen perheenjäsen, ystävä tai hoitaja.",
		"compatibility_list" : "{0} yhteensopivuuslista.",
		"compatibility_link_text_mac" : "Lista Made for iPhone kuulokojeista",
		"compatibility_link_text_windows" : "Tarkista tukeeko Windows 11 PC:si Bluetooth Low Energy Audiota",
		"compatiblity_statement_pc" : "Katso seuraavat tiedot kuulokojeiden tietokonetuesta:",
		"continue_button" : "Jatka",
		"data_removed_body" : "Kaikki tiedot, jotka olet aiemmin suostunut säilyttämään, poistetaan. Tämä sisältää tiedot kuulokojeistasi ja aktiivisuudestasi.",
		"delete_account_header" : "Poista {0} tili",
		"device_may_support_two_way_audio_message" : "Opi lisää tietyn laitteesi suoratoisto-ominaisuuksista,",
		"device_may_support_two_way_audio_message_tap_here" : "napauta tästä",
		"download_app" : "Lataa {0}-sovellus",
		"email_input" : "Anna sähköpostiosoite",
		"email_to_confirm_deletion_body" : "Saat tämän jälkeen sähköpostin, jossa sinua pyydetään vahvistamaan {0} tilisi poistaminen. Poista tilisi noudattamalla ohjeita.",
		"header" : "Olen...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Tietokonettasi ei tueta kuulokojeidemme suoratoistoon.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Suorituskyky saattaa kuitenkin olla rajoitettu laitteesi käyttöjärjestelmän (OS) vuoksi. Jos haluat lisätietoja suositelluista laitteista,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "{0} syötetylle sähköpostiosoitteelle ei löytynyt tilitietoja.",
		"not_recognized" : "Valitettavasti laitettasi ei tunnisteta eikä sitä tueta.",
		"not_tested" : "Laitettasi ei ole täysin testattu. Tällä välin voit ladata sovelluksen, koska monet ominaisuudet toimivat ilman suoratoistoa.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "tai",
		"os_updated_required" : "Laitteesi on tuettu, mutta käyttöjärjestelmän (OS) päivitys tarvitaan.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Henkilökohtaisia tietokoneita ei valitettavasti tueta.",
		"recommended_devices_learn_more_message" : "Oppiaksesi lisää suositelluista laitteista,",
		"sent_check_email" : "Tarkista sähköpostisi",
		"sent_confirmation" : "Jos syötetylle osoitteelle on olemassa tili, sähköposti on lähetetty.",
		"soundgear_amp" : "A",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Laitteesi on tuettu, mutta suoratoisto ei ole käytettävissä.",
		"supported" : "Laitteesi on tuettu!",
		"supported_cannot_update_os" : "Suorituskyky saattaa kuitenkin olla rajoitettu laitteesi käyttöjärjestelmän (OS) vuoksi.",
		"supported_two_way" : "Laitteesi on tuettu ja kykenee handsfree-keskusteluun 2-suuntaisen äänen avulla!",
		"tap_here" : "napauta tästä",
		"test" : "tämä on testi",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Poistaaksesi {0} tilisi, anna sähköpostiosoitteesi ja valitse \"Jatka\".",
		"unable_to_confirm_phone_support" : "Emme voi vahvistaa, onko laitteesi täysin tuettu. Voit ladata sovelluksen, mutta sen suorituskyky voi olla rajoitettu.",
		"wearing_hearing_aids" : "Kuulokojeiden {0} käyttö"
	},
	"fr" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Je suis un membre de la famille, un ami ou un aidant.",
		"aid_type_form_header" : "Je porte...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Compatibilité smartphone",
		"banner_computer_support" : "Assistance informatique pour les appareils auditifs.",
		"banner_device_compatibility" : "Compatibilité appareil",
		"banner_download_page" : "Télécharger l'appli",
		"caregiver" : "un membre de la famille, un ami ou un aidant",
		"caregiver_afton" : "Je suis un membre de la famille, un ami ou un soignant.",
		"compatibility_list" : "Veuillez {0} pour obtenir la liste de compatibilité.",
		"compatibility_link_text_mac" : "Liste des appareils auditifs Made for iPhone",
		"compatibility_link_text_windows" : "Vérifiez si votre PC Windows 11 prend en charge l'audio Bluetooth Low Energy",
		"compatiblity_statement_pc" : "Veuillez vous référer au document suivant pour la prise en charge des appareils auditifs par ordinateur :",
		"continue_button" : "Continuer",
		"data_removed_body" : "Toutes les données précédemment consenties seront supprimées, y compris celles des appareils auditifs et d'activité.",
		"delete_account_header" : "Effacer le compte {0}",
		"device_may_support_two_way_audio_message" : "Pour en savoir plus sur les capacités de streaming de votre appareil spécifique,",
		"device_may_support_two_way_audio_message_tap_here" : "appuyez ici.",
		"download_app" : "Télécharger l'application {0}",
		"email_input" : "Entrer l'adresse email",
		"email_to_confirm_deletion_body" : "Vous recevrez un e-mail vous demandant de confirmer la suppression de votre compte {0}. Suivez les instructions pour supprimer votre compte.",
		"header" : "Je suis...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Votre ordinateur n'est pas compatible avec le streaming vers nos appareils auditifs.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Cependant, vous pourriez rencontrer des performances limitées en raison du système d'exploitation (OS) de votre appareil. Pour en savoir plus sur les appareils recommandés,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Aucune information de compte n'existe pour l'adresse e-mail saisie pour {0}.",
		"not_recognized" : "Désolé, votre appareil n'est pas reconnu et n'est pas pris en charge.",
		"not_tested" : "Votre appareil n'est pas tout à fait prêt. En attendant, vous pouvez télécharger l'appli où de nombreuses fonctions sont opérationnelles sans pour autant devoir recourir au streaming.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "ou",
		"os_updated_required" : "Votre appareil est pris en charge, mais une mise à jour du système d'exploitation (SE) est nécessaire.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Désolé, les ordinateurs personnels ne sont pas pris en charge.",
		"recommended_devices_learn_more_message" : "Pour en savoir plus sur les appareils recommandés,",
		"sent_check_email" : "Vérifiez vos emails.",
		"sent_confirmation" : "Si un compte existe pour l'adresse saisie, un e-mail a été envoyé.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Votre appareil est pris en charge, mais le streaming n'est pas disponible.",
		"supported" : "Votre appareil est pris en charge !",
		"supported_cannot_update_os" : "Cependant, il se peut que les performances soient limitées en raison du système d'exploitation (OS) de votre appareil.",
		"supported_two_way" : "Votre appareil est pris en charge et permet des conversations mains-libres avec Audio bidirectionnel !",
		"tap_here" : "appuyer ici",
		"test" : "ceci est un test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Pour supprimer votre compte {0}, saisissez votre adresse e-mail et sélectionnez « Continuer ».",
		"unable_to_confirm_phone_support" : "Nous ne pouvons pas confirmer si votre appareil est entièrement pris en charge. Vous pouvez télécharger l'application, mais vous pourriez rencontrer des performances limitées.",
		"wearing_hearing_aids" : "un utilisateur d'aides auditives {0}"
	},
	"fr-ca" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Je suis un membre de la famille, un ami ou un aidant.",
		"aid_type_form_header" : "Je porte...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Compatibilité de téléphone intelligent",
		"banner_computer_support" : "Assistance informatique pour les appareils auditifs.",
		"banner_device_compatibility" : "Compatibilité appareil",
		"banner_download_page" : "Télécharger l'appli",
		"caregiver" : "un membre de la famille, un ami ou un soignant",
		"caregiver_afton" : "Je suis un membre de la famille, un ami ou un soignant.",
		"compatibility_list" : "Veuillez {0} pour obtenir la liste de compatibilité.",
		"compatibility_link_text_mac" : "Liste des appareils auditifs Made for iPhone",
		"compatibility_link_text_windows" : "Vérifiez si votre PC Windows 11 prend en charge l'audio Bluetooth Low Energy",
		"compatiblity_statement_pc" : "Veuillez vous référer au document suivant pour la prise en charge des appareils auditifs par ordinateur :",
		"continue_button" : "Continuer",
		"data_removed_body" : "Toutes les données précédemment consenties seront supprimées, y compris celles des appareils auditifs et d'activité.",
		"delete_account_header" : "Effacer le compte {0}",
		"device_may_support_two_way_audio_message" : "Pour en savoir plus sur les capacités de streaming de votre appareil spécifique,",
		"device_may_support_two_way_audio_message_tap_here" : "appuyez ici.",
		"download_app" : "Télécharger l'application {0}",
		"email_input" : "Entrer l'adresse email",
		"email_to_confirm_deletion_body" : "Vous recevrez un e-mail vous demandant de confirmer la suppression de votre compte {0}. Suivez les instructions pour supprimer votre compte.",
		"header" : "Je suis...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Votre ordinateur n'est pas compatible avec le streaming vers nos appareils auditifs.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Cependant, vous pourriez rencontrer des performances limitées en raison du système d'exploitation (OS) de votre appareil. Pour en savoir plus sur les appareils recommandés,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Aucune information de compte n'existe pour l'adresse e-mail saisie pour {0}.",
		"not_recognized" : "Désolé, votre appareil n'est pas reconnu et n'est pas pris en charge.",
		"not_tested" : "Votre appareil n'est pas tout à fait prêt. En attendant, vous pouvez télécharger l'appli où de nombreuses fonctions sont opérationnelles sans pour autant devoir recourir au streaming.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "ou",
		"os_updated_required" : "Votre appareil est pris en charge, mais une mise à jour du système d'exploitation (SE) est nécessaire.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Désolé, les ordinateurs personnels ne sont pas pris en charge.",
		"recommended_devices_learn_more_message" : "Pour en savoir plus sur les appareils recommandés,",
		"sent_check_email" : "Vérifiez vos emails.",
		"sent_confirmation" : "Si un compte existe pour l'adresse saisie, un e-mail a été envoyé.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Votre appareil est pris en charge, mais la diffusion n'est pas disponible.",
		"supported" : "Votre appareil est pris en charge !",
		"supported_cannot_update_os" : "Cependant, il se peut que les performances soient limitées en raison du système d'exploitation (OS) de votre appareil.",
		"supported_two_way" : "Votre appareil est pris en charge et permet des conversations mains-libres avec Audio bidirectionnel !",
		"tap_here" : "appuyer ici",
		"test" : "ceci est un test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Pour supprimer votre compte {0}, saisissez votre adresse e-mail et sélectionnez « Continuer ».",
		"unable_to_confirm_phone_support" : "Nous ne pouvons pas confirmer si votre appareil est entièrement pris en charge. Vous pouvez télécharger l'application, mais vous pourriez rencontrer des performances limitées.",
		"wearing_hearing_aids" : "un utilisateur d'aides auditives {0}"
	},
	"hu" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Hozzátartozó, közeli barát, vagy gondozó vagyok",
		"aid_type_form_header" : "Én viselek...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Okostelefon kompatibilitás",
		"banner_computer_support" : "Számítógépes támogatás hallókészülékekhez.",
		"banner_device_compatibility" : "Eszköz kompatibilitás",
		"banner_download_page" : "Download app",
		"caregiver" : "családtag, barát vagy gondozó",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "A kompatibilitási listáért kérjük, {0}.",
		"compatibility_link_text_mac" : "iPhone-ra optimalizált hallókészülékek listája",
		"compatibility_link_text_windows" : "Ellenőrizze, hogy számítógépe támogatja-e az alacsonenergiás Bluetooth Audiót",
		"compatiblity_statement_pc" : "Kérjük, olvassa el az alábbiakat a hallókészülékek számítógépes támogatásával kapcsolatban:",
		"continue_button" : "Folytatás",
		"data_removed_body" : "Minden adat, amelynek tárolásához korábban hozzájárult, törlésre kerül. Beleértve a hallókészülékkel kapcsolatos és tevékenységi adatokat is.",
		"delete_account_header" : "{0} fiók törlése",
		"device_may_support_two_way_audio_message" : "További információért az Ön konkrét eszközének streamelési képességeiről,",
		"device_may_support_two_way_audio_message_tap_here" : "itt érintse meg.",
		"download_app" : "Töltse le a {0} alkalmazást",
		"email_input" : "Adja meg e-mail címét",
		"email_to_confirm_deletion_body" : "Ezután kap egy e-mailt, amelyben megkérik, hogy erősítse meg a {0} fiók törlését. Kövesse az utasításokat a fiók törléséhez.",
		"header" : "Én",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Az Ön számítógépe nem támogatja a hallókészülékekre történő streamelést.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Előfordulhat azonban, hogy az eszköz operációs rendszere (OS) miatt korlátozott teljesítményt tapasztal. További információért az ajánlott eszközökről,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Nem található fiókinformáció a megadott e-mail címhez a(z) {0} számára.",
		"not_recognized" : "Sajnáljuk, eszközét nem sikerült felismertetni, valószínűleg nem támogatott.",
		"not_tested" : "Eszköze tesztelése még nem befejezett. Az átmeneti időszakra is letöltheti az alkalmazást, mivel számos funkció streamelés (hangátjátszás) nélkül is működhet.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "vagy",
		"os_updated_required" : "Eszköze támogatott, azonban az operációs rendszer (OS) frissítése szükséges.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sajnáljuk, a személyi számítógépek nem támogatottak.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Ellenőrizze e-mail fiókját",
		"sent_confirmation" : "Ha a megadott e-mail címhez tartozik fiók, egy megerősítő levelet küldtünk.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Eszköze támogatott, de a streamelés (hangátjátszás) nem érhető el.",
		"supported" : "Eszköze támogatott!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Eszköze támogatott, és képes a szabad kezes telefonbeszélgetésekre a 2-Way Audio segítségével!",
		"tap_here" : "érintse meg itt",
		"test" : "Ez egy teszt",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "A(z) {0} fiókjának törléséhez adja meg az e-mail címét, és válassza a \"Tovább\" lehetőséget.",
		"unable_to_confirm_phone_support" : "Nem tudjuk megerősíteni, hogy az Ön készüléke teljes mértékben támogatott. Letöltheti az alkalmazást, de előfordulhat, hogy korlátozott teljesítménnyel találkozik.",
		"wearing_hearing_aids" : "{0} hallókészüléket visel"
	},
	"id" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Saya adalah anggota keluarga, teman atau pengasuh",
		"aid_type_form_header" : "Saya memakai…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Kompatibilitas Smartphone",
		"banner_computer_support" : "Dukungan komputer untuk alat bantu dengar.",
		"banner_device_compatibility" : "Kompatibilitas perangkat",
		"banner_download_page" : "Unduh aplikasi",
		"caregiver" : "anggota keluarga, teman, atau pengasuh",
		"caregiver_afton" : "Saya anggota keluarga, teman, atau pengasuh.",
		"compatibility_list" : "Silakan {0} untuk daftar kompatibilitas.",
		"compatibility_link_text_mac" : "Daftar alat bantu dengar yang dibuat untuk iPhone",
		"compatibility_link_text_windows" : "Periksa apakah PC Windows 11 Anda mendukung Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Silakan lihat yang berikut untuk dukungan komputer alat bantu dengar:",
		"continue_button" : "Lanjutkan",
		"data_removed_body" : "Semua data yang sebelumnya Anda setujui untuk disimpan akan dihapus. Ini termasuk alat bantu dengar dan data aktivitas Anda.",
		"delete_account_header" : "Hapus {0} akun",
		"device_may_support_two_way_audio_message" : "Untuk mempelajari lebih lanjut tentang kemampuan streaming untuk perangkat spesifik Anda,",
		"device_may_support_two_way_audio_message_tap_here" : "ketuk di sini.",
		"download_app" : "Unduh aplikasi {0}",
		"email_input" : "Masukkan alamat email",
		"email_to_confirm_deletion_body" : "Anda kemudian akan menerima email yang meminta Anda untuk mengkonfirmasi penghapusan akun {0} Anda. Ikuti instruksi untuk menghapus akun Anda.",
		"header" : "Saya...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Komputer Anda tidak didukung untuk melakukan streaming ke alat bantu dengar kami.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Namun, Anda mungkin mengalami keterbatasan kinerja karena sistem operasi (OS) perangkat Anda. Untuk mempelajari lebih lanjut tentang perangkat yang direkomendasikan,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Tidak ada informasi akun yang tersedia untuk alamat email yang dimasukkan untuk {0}",
		"not_recognized" : "Maaf, perangkat Anda tidak dikenali dan tidak didukung.",
		"not_tested" : "Perangkat Anda belum sepenuhnya diuji. Untuk sementara, Anda dapat mengunduh aplikasinya, karena banyak fitur yang berfungsi tanpa perlu melakukan streaming.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "atau",
		"os_updated_required" : "Perangkat Anda didukung, namun pembaruan sistem operasi (OS) diperlukan.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Maaf, komputer  tidak didukung.",
		"recommended_devices_learn_more_message" : "Untuk mempelajari lebih lanjut tentang perangkat yang direkomendasikan,",
		"sent_check_email" : "Periksa email anda",
		"sent_confirmation" : "Jika ada akun untuk alamat yang dimasukkan, email telah dikirim.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Perangkat Anda didukung, namun streaming tidak tersedia.",
		"supported" : "Perangkat Anda didukung!",
		"supported_cannot_update_os" : "Namun, Anda mungkin mengalami kinerja yang terbatas karena sistem operasi (OS) perangkat Anda.",
		"supported_two_way" : "Perangkat Anda didukung dan mampu melakukan percakapan handsfree dengan Audio 2 Arah!",
		"tap_here" : "ketuk di sini",
		"test" : "ni adalah sebuah pengujian",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Untuk menghapus akun {0} Anda, masukkan alamat email Anda dan pilih \"Lanjutkan.\"",
		"unable_to_confirm_phone_support" : "Kami tidak dapat memastikan apakah perangkat Anda didukung sepenuhnya. Anda dapat mengunduh aplikasi tersebut, tetapi mungkin mengalami keterbatasan kinerja.",
		"wearing_hearing_aids" : "memakai {0} alat bantu dengar"
	},
	"it" : {
		"afflelou_incognito_edge_ai" : "Edge AI in incognito",
		"aid_type_form_caregiver" : "Sono un familiare, un amico o un caregiver",
		"aid_type_form_header" : "Indosso...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Compatibilità Smartphone",
		"banner_computer_support" : "Supporto informatico per apparecchi acustici.",
		"banner_device_compatibility" : "Compatibilità dispositivi",
		"banner_download_page" : "Scarica app",
		"caregiver" : "la app gemella, sono: un famigliare, un amico o un caregiver",
		"caregiver_afton" : "Sono un famigliare, un amico o un caregiver.",
		"compatibility_list" : "Si consiglia {0} per la lista di compatibilità",
		"compatibility_link_text_mac" : "Lista dei dispositivi Made for iPhone",
		"compatibility_link_text_windows" : "Controlla se il tuo PC Windows 11 supporta l'audio con il Bluetooth Low Energy",
		"compatiblity_statement_pc" : "Per il supporto informatico per gli apparecchi acustici, fai riferimento a quanto segue:",
		"continue_button" : "Continua",
		"data_removed_body" : "Tutti i dati a cui hai acconsentito di conservare saranno rimossi. Ciò include i dati relativi all’apparecchio acustico e all’attività.",
		"delete_account_header" : "Elimina account {0}",
		"device_may_support_two_way_audio_message" : "Per saperne di più sulle funzionalità di streaming del tuo dispositivo,",
		"device_may_support_two_way_audio_message_tap_here" : "tocca qua.",
		"download_app" : "Scarica la app {0}",
		"email_input" : "Inserisci l’indirizzo email",
		"email_to_confirm_deletion_body" : "Successivamente riceverai un’email che ti chiederà di confermare l’eliminazione del tuo account {0}. Segui le istruzioni per eliminare il tuo account.",
		"header" : "Io Utilizzo...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Il computer non è supportato per lo streaming con gli apparecchi acustici.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Tuttavia, le prestazioni potrebbero essere limitate a causa del sistema operativo del dispositivo. Per saperne di più sui dispositivi consigliati,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Non esistono informazioni sull'account per l'indirizzo e-mail inserito {0}.",
		"not_recognized" : "Spiacente, il tuto dispositivo non è riconosciuto e non sarà supportato.",
		"not_tested" : "Il tuo dispositivo non è ancora stato testato integralmente, scarica la app le caratteristiche che non hanno bisogno di streaming funzioneranno.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "o",
		"os_updated_required" : "Il tuo dispositivo è supportato, comunque necessita di un aggiornamento del sistema operativo.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Spiacente, il PC non sono supportatti.",
		"recommended_devices_learn_more_message" : "Per saperne di più sui dispositivi consigliati,",
		"sent_check_email" : "Controlla l'email",
		"sent_confirmation" : "Se esiste un account per l'indirizzo inserito, è stata inviata un'e-mail.",
		"soundgear_amp" : "AMP",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Il tuo dispositivo è supportato, comunque lo streaming non sarà disponibile.",
		"supported" : "Il tuo dispositivo è supportato!",
		"supported_cannot_update_os" : "Comunque. potresti avere delle prestazioni limitate dovute al sistema operativo (OS) del tuo dispositivo.",
		"supported_two_way" : "Il tuo dispositivo è supportato anche con la funzione Viva-Voce 2-Way Audio!",
		"tap_here" : "tocca qui",
		"test" : "questo è un test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Per eliminare il tuo account {0}, inserisci il tuo indirizzo email e seleziona \"Continua\".",
		"unable_to_confirm_phone_support" : "Non siamo in grado di confermare se il tuo dispositivo è completamente supportato. È possibile scaricare l'applicazione, ma le prestazioni potrebbero essere limitate.",
		"wearing_hearing_aids" : "Gli apparecchi acustici {0}"
	},
	"ja" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "私は家族、友人、介護者です。",
		"aid_type_form_header" : "私は補聴器を使用",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "スマートフォンの互換性",
		"banner_computer_support" : "補聴器のコンピュータサポート。",
		"banner_device_compatibility" : "スマートフォンの互換性",
		"banner_download_page" : "Download app",
		"caregiver" : "ご家族、友人、介護者（補聴器ユーザー以外の方）",
		"caregiver_afton" : "私は家族、友人、介護者です。",
		"compatibility_list" : "互換性リストは {0} してご覧ください。",
		"compatibility_link_text_mac" : "iPhone用補聴器互換性リスト",
		"compatibility_link_text_windows" : "お使いのWindows 11 パソコンがBluetooth Low Energy Audioに対応していることを確認してください。",
		"compatiblity_statement_pc" : "補聴器のコンピュータサポートについては、以下をご参照ください：",
		"continue_button" : "続ける",
		"data_removed_body" : "お客様が以前に同意された保存データはすべて消去されます。これには補聴器や 身体活動データも含まれます。",
		"delete_account_header" : "{0} アカウントを削除",
		"device_may_support_two_way_audio_message" : "端末のストリーミング機能について詳しい情報は、こちらをご覧ください、",
		"device_may_support_two_way_audio_message_tap_here" : "ここをタップ",
		"download_app" : "{0}アプリをダウンロード",
		"email_input" : "メールアドレスを入力",
		"email_to_confirm_deletion_body" : "この後、お客様に {0} アカウントの削除を確認するメールが届きます。指示に従って、アカウントを削除してください。",
		"header" : "私は…",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "お使いのパソコンは補聴器へのストリーミングには対応していません。",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "ただし、お使いのデバイスのオペレーティングシステム（OS）により、パフォーマンスが制限される場合があります。推奨デバイスの詳細については、こちらをご覧ください。",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "{0}に入力されたメールアドレスはアカウント情報が存在しません。",
		"not_recognized" : "残念ながら、お使いの端末は認識されず、サポートされていません。",
		"not_tested" : "お使いの端末は互換性が確認されていません。アプリのダウンロードはできますが、ストリーミングを必要とする機能などは使用できません。",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "または",
		"os_updated_required" : "お使いの端末はサポートされていますが、オペレーションシステム（OS）のアップデートが必要です。",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "申し訳ございませんが、パーソナルコンピュータ（PC）はサポートされていません。",
		"recommended_devices_learn_more_message" : "おすすめのデバイスについてもっと詳しく",
		"sent_check_email" : "メールをご確認ください",
		"sent_confirmation" : "入力されたアドレスにアカウントが存在する場合は、メールが送信されています。",
		"soundgear_amp" : "AMP",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "お使いの端末はサポートされていますが、ストリーミング機能を利用できません。",
		"supported" : "お使いの端末はサポートされています！",
		"supported_cannot_update_os" : "ただし、お使いのデバイスのオペレーティングシステム（OS）により、パフォーマンスが制限される場合があります。",
		"supported_two_way" : "お使いの端末は補聴器の２ウェイオーディオに対応し、ハンズフリーで会話できます！",
		"tap_here" : "ここをタップ",
		"test" : "これはテストです",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "{0} アカウントを削除するには、メールアドレスを入力して「続ける」を選択します。",
		"unable_to_confirm_phone_support" : "お使いのデバイスが対応しているかどうか確認できませんでした。アプリのダウンロードは可能ですが、パフォーマンスが制限される場合があります。",
		"wearing_hearing_aids" : "{0} 補聴器を使用"
	},
	"ko" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "저는 가족 구성원, 친구 또는 건강관리자 입니다.",
		"aid_type_form_header" : "제가 사용중인 보청기는...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "스마트폰 호환 정보",
		"banner_computer_support" : "컴퓨터가 보청기를 지원 합니다.",
		"banner_device_compatibility" : "기기 호환성",
		"banner_download_page" : "앱 다운로드",
		"caregiver" : "가족, 친구 및/또는 캐어관리자",
		"caregiver_afton" : "저는 가족, 친구 또는 건강관리자 입니다,",
		"compatibility_list" : "호환성 리스트를 {0}에서 확인하여 주십시오.",
		"compatibility_link_text_mac" : "MFI 보청기 리스트",
		"compatibility_link_text_windows" : "사용중인 Windows 11 PC가 Bluetooth Low Energy Audio를 지원한다면 체크 하십시오.",
		"compatiblity_statement_pc" : "보청기를 지원하는 PC 정보는 다음을 참조 하십시오.:",
		"continue_button" : "계속",
		"data_removed_body" : "이전에 동의하여 저장 되었던 모든 데이터가 삭제될 것 입니다. 보청기 데이터 및 활동 데이터 역시 삭제될 것 입니다.",
		"delete_account_header" : "{0} 계정 삭제",
		"device_may_support_two_way_audio_message" : "사용중인 기기의 스트리밍 성능에 대하여 더 알아 보기",
		"device_may_support_two_way_audio_message_tap_here" : "여기를 탭.",
		"download_app" : "{0} 앱을 다운로드 하십시오.",
		"email_input" : "이메일 주소 입력",
		"email_to_confirm_deletion_body" : "{0} 계정을 삭제할 것 인지 확인하는 이메일을 수신할 것 입니다. 계정을 삭제 하려면  제공되는 단계를 잘 수행 하시면 됩니다.",
		"header" : "저는...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "사용중인 PC 와 보청기의 스트리밍 가능이 호환 되지 않습니다.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink 지원",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "하지만, 사용중인 운영체계(OS)로 인하여 제한적인 가능만 수행할수 있을것 입니다. 추천하는 기기들에 대하여 더 알아보시려면 다음을 참조 하십시오.",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "{0}을 위하여 입력한 이메일 주소에 기초한 계정정보가 없습니다.",
		"not_recognized" : "죄송합니다. 기기가 인식되지 않고 지원되지 않습니다.",
		"not_tested" : "기기의 테스트가 완료되었습니다. 앱을 다운로드하시면 스트리밍을 하지 않더라도 다양한 기능을 미리 체험하여 볼 수 있습니다.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "또는",
		"os_updated_required" : "지원되는 기기 입니다만, 업데이트가 선행되어야 합니다.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "죄송합니다. 개인용 컴퓨터는 지원되지 않습니다.",
		"recommended_devices_learn_more_message" : "추천하는 기기들에 대하여 더 알아보고자 한다면,",
		"sent_check_email" : "이메일을 확인 하십시오",
		"sent_confirmation" : "입력한 주소에 이미 계정이 존재한다면, 이메일이 발송 될 것 입니다.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "지원되는 기기 입니다만, 스트리밍은 불가능 합니다.",
		"supported" : "지원되는 기기 입니다!",
		"supported_cannot_update_os" : "하지만, 기기의 운영체계(OS)로 인하여 일부 가능이 제한될수 있습니다.",
		"supported_two_way" : "지원되는 기기이며, 양방향 통신기능을 활용하여 핸드프리 전화통화가 가능 합니다.",
		"tap_here" : "여기를 탭하십시오",
		"test" : "테스트 입니다.",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "{0} 계정을 삭제 하시려면, 이메일 주소를 입력하시고 \"계속\"을 선택하십시오.",
		"unable_to_confirm_phone_support" : "사용중인 기기와 완벽하게 호환되는지 확신하기 어렵습니다. 앱을 다운로드하여 사용할수는 있으나 그 기능의 일부는 제한될것 입니다.",
		"wearing_hearing_aids" : "{0}보청기 착용"
	},
	"nl" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Ik ben een familielid, vriend of verzorger",
		"aid_type_form_header" : "Ik draag...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibiliteit",
		"banner_computer_support" : "Computerondersteuning voor hoortoestellen.",
		"banner_device_compatibility" : "Compatibiliteit van apparaten",
		"banner_download_page" : "Download app",
		"caregiver" : "ben familie, een vriend of mantelzorger.",
		"caregiver_afton" : "Ik ben een familielid, vriend of verzorger.",
		"compatibility_list" : "A.u.b. {0} voor een lijst met compatibele apparaten.",
		"compatibility_link_text_mac" : "Lijst met Made for iPhone-hoortoestellen",
		"compatibility_link_text_windows" : "Controleer of uw Windows 11-pc Bluetooth Low Energy Audio ondersteunt",
		"compatiblity_statement_pc" : "Raadpleeg het volgende voor computerondersteuning van hoortoestellen:",
		"continue_button" : "Doorgaan",
		"data_removed_body" : "Alle gegevens waarvoor u eerder toestemming hebt gegeven om ze op te slaan, worden verwijderd. Dit geldt ook voor uw hoortoestel- en activiteitsgegevens.",
		"delete_account_header" : "Account {0} verwijderen",
		"device_may_support_two_way_audio_message" : "Voor meer informatie over de streamingmogelijkheden van uw specifieke apparaat,",
		"device_may_support_two_way_audio_message_tap_here" : "tik hier.",
		"download_app" : "Download de {0} app",
		"email_input" : "E-mailadres invoeren",
		"email_to_confirm_deletion_body" : "Je ontvangt dan een e-mail waarin je wordt gevraagd om de verwijdering van uw {0} account te bevestigen. Volg de instructies om uw account te verwijderen.",
		"header" : "Ik ben...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Uw computer wordt niet ondersteund voor streaming naar onze hoortoestellen.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "U kunt echter beperkte prestaties ervaren door het besturingssysteem (OS) van uw apparaat. Voor meer informatie over aanbevolen apparaten,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Er bestaan geen accountgegevens voor het e-mailadres dat is ingevoerd voor {0}.",
		"not_recognized" : "Sorry, uw apparaat is niet herkend en wordt niet ondersteund.",
		"not_tested" : "Uw smartphone is niet volledig getest. In de tussenliggende tijd kunt u wel de app downloaden, omdat veel functies werken zonder dat het nodig is om te streamen.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "of",
		"os_updated_required" : "Uw smartphone wordt ondersteund, maar er is wel een update van het besturingssysteem (OS) nodig.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, pc's worden niet ondersteund.",
		"recommended_devices_learn_more_message" : "Voor meer informatie over aanbevolen apparaten,",
		"sent_check_email" : "Controleer uw e-mail",
		"sent_confirmation" : "Als er een account bestaat voor het ingevoerde adres, wordt er een e-mail verzonden.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Uw smartphone wordt ondersteund, maar de mogelijkheid om te streamen is niet beschikbaar.",
		"supported" : "Uw smartphone wordt volledig ondersteund!",
		"supported_cannot_update_os" : "U kunt echter beperkte prestaties ervaren als gevolg van het besturingssysteem (OS) van uw apparaat.",
		"supported_two_way" : "Uw smartphone wordt ondersteund en is geschikt voor volledig handsfree conversaties door middel van 2-weg Audio!",
		"tap_here" : "Druk hier",
		"test" : "Dit is een test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Om uw {0} account te verwijderen, voert u uw e-mailadres in en selecteert u \"Doorgaan\".",
		"unable_to_confirm_phone_support" : "We kunnen niet bevestigen of uw apparaat volledig wordt ondersteund. U kunt de app downloaden, maar de prestaties zijn mogelijk beperkt.",
		"wearing_hearing_aids" : "draag {0} hoortoestellen"
	},
	"nl-be" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Ik ben een familielid, vriend of verzorger",
		"aid_type_form_header" : "Ik draag...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibiliteit",
		"banner_computer_support" : "Computerondersteuning voor hoortoestellen.",
		"banner_device_compatibility" : "Compatibiliteit van apparaten",
		"banner_download_page" : "Download app",
		"caregiver" : "ben familie, een vriend of mantelzorger.",
		"caregiver_afton" : "Ik ben een familielid, vriend of verzorger.",
		"compatibility_list" : "A.u.b. {0} voor een lijst met compatibele apparaten.",
		"compatibility_link_text_mac" : "Lijst met Made for iPhone-hoortoestellen",
		"compatibility_link_text_windows" : "Controleer of uw Windows 11-pc Bluetooth Low Energy Audio ondersteunt",
		"compatiblity_statement_pc" : "Raadpleeg het volgende voor computerondersteuning van hoortoestellen:",
		"continue_button" : "Doorgaan",
		"data_removed_body" : "Alle gegevens waarvoor u eerder toestemming hebt gegeven om ze op te slaan, worden verwijderd. Dit geldt ook voor uw hoortoestel- en activiteitsgegevens.",
		"delete_account_header" : "Account {0} verwijderen",
		"device_may_support_two_way_audio_message" : "Voor meer informatie over de streamingmogelijkheden van uw specifieke apparaat,",
		"device_may_support_two_way_audio_message_tap_here" : "tik hier.",
		"download_app" : "Download de {0} app",
		"email_input" : "E-mailadres invoeren",
		"email_to_confirm_deletion_body" : "Je ontvangt dan een e-mail waarin je wordt gevraagd om de verwijdering van uw {0} account te bevestigen. Volg de instructies om uw account te verwijderen.",
		"header" : "Ik ben...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Uw computer wordt niet ondersteund voor streaming naar onze hoortoestellen.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "U kunt echter beperkte prestaties ervaren door het besturingssysteem (OS) van uw apparaat. Voor meer informatie over aanbevolen apparaten,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Er bestaan geen accountgegevens voor het e-mailadres dat is ingevoerd voor {0}.",
		"not_recognized" : "Sorry, uw apparaat is niet herkend en wordt niet ondersteund.",
		"not_tested" : "Uw smartphone is niet volledig getest. In de tussenliggende tijd kunt u wel de app downloaden, omdat veel functies werken zonder dat het nodig is om te streamen.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "of",
		"os_updated_required" : "Uw smartphone wordt ondersteund, maar er is wel een update van het besturingssysteem (OS) nodig.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, pc's worden niet ondersteund.",
		"recommended_devices_learn_more_message" : "Voor meer informatie over aanbevolen apparaten,",
		"sent_check_email" : "Controleer uw e-mail",
		"sent_confirmation" : "Als er een account bestaat voor het ingevoerde adres, wordt er een e-mail verzonden.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Uw smartphone wordt ondersteund, maar de mogelijkheid om te streamen is niet beschikbaar.",
		"supported" : "Uw smartphone wordt volledig ondersteund!",
		"supported_cannot_update_os" : "U kunt echter beperkte prestaties ervaren als gevolg van het besturingssysteem (OS) van uw apparaat.",
		"supported_two_way" : "Uw smartphone wordt ondersteund en is geschikt voor volledig handsfree conversaties door middel van 2-weg Audio!",
		"tap_here" : "Druk hier",
		"test" : "Dit is een test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Om uw {0} account te verwijderen, voert u uw e-mailadres in en selecteert u \"Doorgaan\".",
		"unable_to_confirm_phone_support" : "We kunnen niet bevestigen of uw apparaat volledig wordt ondersteund. U kunt de app downloaden, maar de prestaties zijn mogelijk beperkt.",
		"wearing_hearing_aids" : "draag {0} hoortoestellen"
	},
	"no" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Jeg er et familiemedlem, venn eller omsorgsperson",
		"aid_type_form_header" : "Jeg bruker...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Kompabilitet med smarttelefon",
		"banner_computer_support" : "Datastøtte for høreapparater.",
		"banner_device_compatibility" : "Kompabilitet med enheter",
		"banner_download_page" : "Download app",
		"caregiver" : "et familiemedlem, en venn eller omsorgsperson",
		"caregiver_afton" : "Jeg er et familiemedlem, venn eller omsorgsperson.",
		"compatibility_list" : "Vennligst {0} for en kompabilitetsliste.",
		"compatibility_link_text_mac" : "Liste over Made for iPhone-høreapparater",
		"compatibility_link_text_windows" : "Sjekk om din Windows 11-PC støtter Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Se følgende for datamaskinstøtte for høreapparater:",
		"continue_button" : "Fortsett",
		"data_removed_body" : "Alle data du tidligere har samtykket til å bli lagret, vil bli fjernet. Dette inkluderer høreapparat- og aktivitetsdata.",
		"delete_account_header" : "Slett {0} konto",
		"device_may_support_two_way_audio_message" : "For å lære mer om strømmefunksjoner for din spesifikke enhet,",
		"device_may_support_two_way_audio_message_tap_here" : "trykk her.",
		"download_app" : "Last ned {0} app",
		"email_input" : "Skriv inn e-postadresse",
		"email_to_confirm_deletion_body" : "Du vil da motta en e-post som ber deg bekrefte slettingen av {0}kontoen din. Følg veiledningen for å slette kontoen din.",
		"header" : "Jeg er...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Datamaskinen din støttes ikke for streaming til høreapparatene våre.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Du kan imidlertid oppleve begrenset ytelse på grunn av enhetens operativsystem (OS). For å lære mer om anbefalte enheter,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Det finnes ingen kontoinformasjon for e-postadressen som er angitt for {0}.",
		"not_recognized" : "Beklager, enheten gjenkjennes ikke og støttes ikke.",
		"not_tested" : "Enheten er ikke fullstendig testet. I mellomtiden kan du laste ned appen, mange funksjoner fungerer uten å måtte streame.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "eller",
		"os_updated_required" : "Din enhet støttes, men en oppdatering av (OS) er nødvendig.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Beklager, det er ikke støtte for PC.",
		"recommended_devices_learn_more_message" : "For å lære mer om anbefalte enheter,",
		"sent_check_email" : "Sjekk din e-post",
		"sent_confirmation" : "Hvis det finnes en konto for den angitte adressen, er det sendt en e-post.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Din enhet støttes, men streaming er ikke tilgjengelig.",
		"supported" : "Din enhet støttes!",
		"supported_cannot_update_os" : "Du kan imidlertid oppleve begrenset ytelse på grunn av enhetens operativsystem (OS).",
		"supported_two_way" : "Din enhet støttes og er i stand til hands-free samtaler med 2-veis audio!",
		"tap_here" : "trykk her",
		"test" : "dette er en test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "For å slette {0}kontoen din, skriv inn e-postadressen din og velg \"Fortsett\".",
		"unable_to_confirm_phone_support" : "Vi kan ikke bekrefte om enheten din støttes fullt ut. Du kan laste ned appen, men kan oppleve begrenset ytelse.",
		"wearing_hearing_aids" : "bruker {0} høreapparater"
	},
	"pl" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Jestem członkiem rodziny, przyjacielem lub opiekunem",
		"aid_type_form_header" : "Jestem użytkownikiem",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Kompatybilność ze smartfonami",
		"banner_computer_support" : "Wsparcie komputerowe dla aparatów słuchowych.",
		"banner_device_compatibility" : "Kompatybilność urządzenia",
		"banner_download_page" : "Download app",
		"caregiver" : "członek rodziny, przyjaciel lub opiekun",
		"caregiver_afton" : "Jestem członkiem rodziny, przyjacielem lub opiekunem.",
		"compatibility_list" : "Proszę {0} o listę kompatybilności.",
		"compatibility_link_text_mac" : "Lista urządzeń słuchowych stworzonych dla iPhone",
		"compatibility_link_text_windows" : "Sprawdź, czy komputer z systemem Windows 11 obsługuje funkcję Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Poniższe informacje dotyczą komputerowej obsługi aparatów słuchowych:",
		"continue_button" : "Kontynuuj",
		"data_removed_body" : "Wszystkie dane, na których przechowywanie użytkownik wyraził wcześniej zgodę, zostaną usunięte. Obejmuje to dane dotyczące aparatów słuchowych i aktywności.",
		"delete_account_header" : "Usuń konto {0}",
		"device_may_support_two_way_audio_message" : "Aby dowiedzieć się więcej o możliwościach przesyłania strumieniowego dla danego urządzenia,",
		"device_may_support_two_way_audio_message_tap_here" : "dotknij tutaj.",
		"download_app" : "Pobierz aplikację {0}",
		"email_input" : "Wprowadź adres e-mail",
		"email_to_confirm_deletion_body" : "Następnie otrzymasz wiadomość e-mail z prośbą o potwierdzenie usunięcia konta {0}. Postępuj zgodnie z instrukcjami, aby usunąć swoje konto.",
		"header" : "Ja jestem...",
		"hear_circle" : "Krąg słyszenia",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Twój komputer nie obsługuje przesyłania strumieniowego do naszych aparatów słuchowych.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Wydajność może być jednak ograniczona ze względu na system operacyjny urządzenia. Aby dowiedzieć się więcej o zalecanych urządzeniach,",
		"my_audibel" : "Mój Audibel",
		"my_phantom" : "Mój Phantom",
		"my_sound_gear" : "Mój SoundGear",
		"my_starkey" : "Mój Starkey",
		"no_account_exists_for_email" : "Nie istnieją informacje o koncie dla adresu e-mail wprowadzonego dla {0}.",
		"not_recognized" : "Przepraszamy, Twoje urządzenie nie zostało rozpoznane i nie jest obsługiwane.",
		"not_tested" : "Twoje urządzenie nie jest w pełni przetestowane. W międzyczasie możesz pobrać aplikację, ponieważ wiele funkcji działa bez konieczności strumieniowania.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "lub",
		"os_updated_required" : "Urządzenie jest obsługiwane, ale konieczna jest aktualizacja systemu operacyjnego (OS).",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Przepraszamy, komputery osobiste nie są obsługiwane.",
		"recommended_devices_learn_more_message" : "Aby dowiedzieć się więcej o zalecanych urządzeniach,",
		"sent_check_email" : "Sprawdź swoją pocztę email",
		"sent_confirmation" : "Jeśli dla wprowadzonego adresu istnieje konto, wiadomość e-mail została wysłana.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Twoje urządzenie jest obsługiwane, ale strumieniowanie nie jest dostępne.",
		"supported" : "Twoje urządzenie jest obsługiwane!",
		"supported_cannot_update_os" : "Wydajność może być jednak ograniczona ze względu na system operacyjny urządzenia.",
		"supported_two_way" : "Twoje urządzenie jest obsługiwane i może prowadzić rozmowy bez użycia rąk dzięki funkcji 2-Way Audio!",
		"tap_here" : "stuknij tutaj",
		"test" : "to jest test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Aby usunąć konto {0}, wprowadź swój adres e-mail i wybierz \"Kontynuuj\".",
		"unable_to_confirm_phone_support" : "Nie jesteśmy w stanie potwierdzić, czy Twoje urządzenie jest w pełni obsługiwane. Aplikację można pobrać, ale jej wydajność może być ograniczona.",
		"wearing_hearing_aids" : "noszenie {0} aparatów słuchowych"
	},
	"pt" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"pt-br" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Eu sou um familiar, amigo ou cuidador",
		"aid_type_form_header" : "Eu estou usando...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Compatibilidade com smartphone",
		"banner_computer_support" : "Suporte do computador para aparelhos auditivos",
		"banner_device_compatibility" : "Compatibilidade do dispositivo",
		"banner_download_page" : "Download app",
		"caregiver" : "um familiar, amigo ou cuidador",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Por favor, {0} para a lista de compatibilidade.",
		"compatibility_link_text_mac" : "Lista de dispositivos Made For Iphone",
		"compatibility_link_text_windows" : "Verifique se o seu PC com Windows 11 oferece suporte a áudio de Bluetooth de baixa energia",
		"compatiblity_statement_pc" : "Por favor consulte o seguinte para suporte de computador para aparelhos auditivos",
		"continue_button" : "Continue",
		"data_removed_body" : "Todos os dados que você consentiu ser armazenados serão excluídos. Isso inclui seus dados de uso e atividade dos aparelhos auditivos.",
		"delete_account_header" : "Deletar {0} conta",
		"device_may_support_two_way_audio_message" : "Para saber mais sobre a capacidade de transmissão do seu aparelho específico,",
		"device_may_support_two_way_audio_message_tap_here" : "Clique aqui.",
		"download_app" : "Baixe o aplicativo {0}",
		"email_input" : "Informe endereço de e-mail",
		"email_to_confirm_deletion_body" : "Você vai receber um e-mail pedindo para confirmar que quer apagar sua {0} conta. Siga as instruções dele para apagar sua conta.",
		"header" : "Eu sou...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Seu computador não tem suporte para transmitir seus aparelhos auditivos.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Entretanto voce pode experenciar desempenho limitado devido ao sistema operacional (OS) do seu dispositivo. Para saber mais sobre dispositivos recomendados.",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "Nenhuma informação de conta existe para o e-mail informado {0}.",
		"not_recognized" : "Desculpe, seu dispositivo não é reconhecido e não é suportado.",
		"not_tested" : "Seu dispositivo não foi completamente testado. enquanto isso, você pode baixar o aplicativo, já que muitos recursos funcionam sem a necessidade de transmissão.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "ou",
		"os_updated_required" : "Seu dispositivo é suportado, porém é necessária uma atualização de sistema (OS).",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Desculpe, computadores não são suportados.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Verifique seu e-mai",
		"sent_confirmation" : "Se uma conta já existe para o endereço de e-mail inserido, um e-mail será enviado.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Seu dispositivo não é suportado, entretanto transmissões não estão disponíveis.",
		"supported" : "Seu dispositivo é suportado!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Seu dispositivo é suportado e é capaz de realizar conversas usando a tecnologia de áudio bidirecional!",
		"tap_here" : "toque aqui",
		"test" : "isso é um teste",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Para deletar sua {0} conta, insira seu endereço de e-mail e selecione \"Continuar\".",
		"unable_to_confirm_phone_support" : "Não pudemos confirmar se o seu dispositivo é completamente suportado. Você pode baixar o aplicativo mas pode experienciar um desempenho limitado.",
		"wearing_hearing_aids" : "usando aparelhos auditivos {0}"
	},
	"ru" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "Я член семьи, друг или опекун",
		"aid_type_form_header" : "Я ношу…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Совместимость со смартфоном",
		"banner_computer_support" : "Компьютерная поддержка слуховых аппаратов.",
		"banner_device_compatibility" : "Совместимость устройств",
		"banner_download_page" : "Установить",
		"caregiver" : "член семьи, друг, опекун",
		"caregiver_afton" : "Я член семьи, друг или опекун.",
		"compatibility_list" : "Пожалуйста, {0} для списка совместимости.",
		"compatibility_link_text_mac" : "Список слуховых аппаратов Made for iPhone",
		"compatibility_link_text_windows" : "Проверьте, поддерживает ли ваш ПК с Windows 11 технологию Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Информацию о компьютерной поддержке слуховых аппаратов см. ниже:",
		"continue_button" : "Продолжить",
		"data_removed_body" : "Все данные, на сохранение которых вы ранее согласились, будут удалены. Сюда входят данные о вашем слуховом аппарате и активности.",
		"delete_account_header" : "Удалить {0} аккаунт",
		"device_may_support_two_way_audio_message" : "Чтобы узнать больше о возможностях потоковой передачи для вашего конкретного устройства,",
		"device_may_support_two_way_audio_message_tap_here" : "нажмите здесь.",
		"download_app" : "Загрузить приложение {0}",
		"email_input" : "Введите адрес своей эл. почты",
		"email_to_confirm_deletion_body" : "Вы получите электронное письмо с просьбой подтвердить удаление вашей учетной записи {0}. Следуйте инструкциям, чтобы удалить свою учетную запись.",
		"header" : "Я…",
		"hear_circle" : "Цикл прослушивания",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Ваш компьютер не поддерживает потоковую передачу на наши слуховые аппараты.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "Однако вы можете столкнуться с ограниченной производительностью из-за операционной системы (ОС) вашего устройства. Чтобы узнать больше о рекомендуемых устройствах,",
		"my_audibel" : "Мой Audibel",
		"my_phantom" : "Мой Phantom",
		"my_sound_gear" : "Мой SoundGear",
		"my_starkey" : "Мой Starkey",
		"no_account_exists_for_email" : "Для указанного адреса электронной почты {0} не существует учетной записи.",
		"not_recognized" : "К сожалению, ваше устройство не распознано и не поддерживается.",
		"not_tested" : "Ваше устройство не полностью протестировано. А пока вы можете скачать приложение, так как многие функции работают без потоковой передачи.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "или",
		"os_updated_required" : "Ваше устройство поддерживается, однако, операционная система (ОС) нуждается в обновлении.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "К сожалению, персональные компьютеры не поддерживаются.",
		"recommended_devices_learn_more_message" : "Чтобы узнать больше о рекомендуемых устройствах,",
		"sent_check_email" : "Проверьте свою эл. Почту",
		"sent_confirmation" : "Если для введенного адреса существует учетная запись, будет отправлено электронное письмо.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Ваше устройство поддерживается, однако, стриминг не доступен.",
		"supported" : "Ваше устройство поддерживается!",
		"supported_cannot_update_os" : "Однако, производительность может быть ограничена из-за операционной системы (ОС) вашего устройства.",
		"supported_two_way" : "Ваше устройство поддерживается и поддерживает разговоры в режиме громкой связи с двусторонней аудиосвязью!",
		"tap_here" : "нажмите здесь",
		"test" : "это тест",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "Чтобы удалить свою учетную запись {0}, введите свой адрес электронной почты и нажмите «Продолжить».",
		"unable_to_confirm_phone_support" : "Мы не можем подтвердить, полностью ли поддерживается ваше устройство. Вы можете загрузить приложение, но производительность может быть ограничена.",
		"wearing_hearing_aids" : "ношение {0} слуховых аппаратов"
	},
	"sv" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Smartphone compatibility",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "a family member, friend, or caregiver",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Please {0} for a compatibility list.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Continue",
		"data_removed_body" : "All data you previously consented to be stored will be removed. This includes your hearing aid and activity data.",
		"delete_account_header" : "Delete {0} account",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "Download the {0} app",
		"email_input" : "Enter email address",
		"email_to_confirm_deletion_body" : "You will then receive an email asking you to confirm the deletion of your {0} account. Follow the instructions to delete your account.",
		"header" : "I am...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Sorry, your device is not recognized and is not supported.",
		"not_tested" : "Your device is not fully tested. In the interim, you can download the app, as many features work without needing to stream.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Your device is supported, however an operating system (OS) update is needed.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Sorry, personal computers are not supported.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Your device is supported, however streaming is not available.",
		"supported" : "Your device is supported!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Your device is supported and capable of hands-free conversations with 2-Way Audio!",
		"tap_here" : "tap here",
		"test" : "this is a test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "To delete your {0} account, enter your email address and select \"Continue.\"",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "wearing {0} hearing aids"
	},
	"th" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "ฉันเป็นสมาชิกในครอบครัว เพื่อน หรือผู้ดูแล",
		"aid_type_form_header" : "ฉันกำลังใส่…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "กาารองรับสมาร์ทโฟน",
		"banner_computer_support" : "การช่วยเหลือด้านคอมพิวเตอร์ของเครื่องช่วยฟัง",
		"banner_device_compatibility" : "ความเข้ากันได้ของอุปกรณ์",
		"banner_download_page" : "Download app",
		"caregiver" : "สมาชิกครอบครัว เพื่อน หรือผู้ดูแล",
		"caregiver_afton" : "ฉันเป็นสมาชิกครอบครัว เพื่อน หรือผู้ดูแล",
		"compatibility_list" : "กรุณา {0} สำหรับรายการที่รองรับ",
		"compatibility_link_text_mac" : "รายการเครื่องช่วยฟัง Made for iPhone",
		"compatibility_link_text_windows" : "ตรวจสอบว่า Windows 11 PC รองรับระบบพลังงานต่ำ Bluetooth",
		"compatiblity_statement_pc" : "กรุณาติดต่อขอความช่วยเหลือด้านคอมพิวเตอร์ของเครื่องช่วยฟัง:",
		"continue_button" : "ดำเนินการต่อ",
		"data_removed_body" : "ข้อมูลทั้งหมดที่คุณได้ยินยอมก่อนหน้าที่เก็บไว้จะถูกลบออก ซึ่งรวมถึงข้อมูลเครื่องช่วยฟังและกิจกรรมของคุณ",
		"delete_account_header" : "ลบบัญชี {0}",
		"device_may_support_two_way_audio_message" : "เพื่อเรียนรู้เพิ่มเติมเกี่ยวกับความสามารถในการสตรีมมิ่งสำหรับอุปกรณ์เฉพาะของคุณ",
		"device_may_support_two_way_audio_message_tap_here" : "แตะที่นี่",
		"download_app" : "ดาวน์โหลด {0} app",
		"email_input" : "กรอกที่อยู่อีเมล์",
		"email_to_confirm_deletion_body" : "คุณจะได้รับอีเมล์ถามเพื่อยืนยันการลบบัญชี {0}  ทำตามคำแนะนำเพื่อลบบัญชีของคุณ",
		"header" : "ฉันเป็น...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "คอมพิวเตอร์ของคุณไม่รองรับการสตรีมมิ่งไปยังเครื่องช่วยฟัง",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "อย่างไรก็ตาม คุณอาจพบว่าประสิทธิภาพการทำงานลดลงเนื่องจากระบบปฏิบัติการ (OS) ของอุปกรณ์ของคุณ หากต้องการเรียนรู้เพิ่มเติมเกี่ยวกับอุปกรณ์ที่แนะนำ",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "ไม่มีข้อมูลบัญชีอยู่สำหรับที่อยู่อีเมล์ที่กรอก {0}",
		"not_recognized" : "เสียใจด้วย อุปกรณ์ของคุณใช้ไม่ได้และไม่รองรับ",
		"not_tested" : "อุปกรณ์ของคุณไม่ได้รับการทดสอบเต็มรูปแบบ ระหว่างการทดสอบคุณสามารถดาวน์โหลดแอพ โดยให้คุณสมบัติต่างๆทำงาน ปราศจากการสตรีมสัญญาณ",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "หรือ",
		"os_updated_required" : "อุปกรณ์ของคุณไม่รองรับ แต่จำเป็นต้องอัพเดทระบบปฏิบัติการ (OS)",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "เสียใจด้วย คอมพิวเตอร์ส่วนบุคคลไม่รองรับ",
		"recommended_devices_learn_more_message" : "เพื่อเรียนรู้เพิ่มเติมเกี่ยวกับอุปกรณ์ที่แนะนำ",
		"sent_check_email" : "เช็คอีเมล์ของคุณ",
		"sent_confirmation" : "หากบัญชีมีอยู่แล้วด้วยที่อยู่ที่กรอก อีเมล์จะถูกส่งไปยังที่อยู่",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "อุปกรณ์ของคุณไม่รองรับ แต่การสตรีมมิ่งไม่มีอยู่",
		"supported" : "อุปกรณ์ของคุณได้รับการรองรับ!",
		"supported_cannot_update_os" : "อย่างไรก็ตาม คุณอาจพบกับประสิทธิภาพที่จำกัดเนื่องจากระบบปฏิบัติการ (OS) ของอุปกรณ์ของคุณ",
		"supported_two_way" : "อุปกรณ์ของคุณได้รับการรองรับ และสามารถสื่อสารแบบไร้สายด้วย 2-Way Audio!",
		"tap_here" : "แตะที่นี่",
		"test" : "นี่คือการทดสอบ",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "เพื่อลบบัญชี {0} กรอกที่อยู่อีเมล์และเลือก \"ดำเนินการ\"",
		"unable_to_confirm_phone_support" : "เราไม่สามารถยืนยันได้ว่าอุปกรณ์ของคุณได้รับการรองรับทั้งหมดหรือไม่ คุณสามารถดาวน์โหลดแอพได้ แต่ประสิทธิภาพการใช้งานอาจจำกัด",
		"wearing_hearing_aids" : "กำลังใส่เครื่องช่วยฟัง {0}"
	},
	"tr" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "I am a family member, friend or caregiver",
		"aid_type_form_header" : "I am wearing…",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "Akıllı Telefon Uyumluluğu",
		"banner_computer_support" : "Computer support for hearing aids.",
		"banner_device_compatibility" : "Device compatibility",
		"banner_download_page" : "Download app",
		"caregiver" : "bir aile üyesi, arkadaş veya yardımcı",
		"caregiver_afton" : "I am a family member, friend, or caregiver.",
		"compatibility_list" : "Uyumluluk listesi için lütfen {0}.",
		"compatibility_link_text_mac" : "List of Made for iPhone hearing devices",
		"compatibility_link_text_windows" : "Check if your Windows 11 PC supports Bluetooth Low Energy Audio",
		"compatiblity_statement_pc" : "Please refer to the following for computer support of hearing aids:",
		"continue_button" : "Devam Et",
		"data_removed_body" : "Daha önce saklanmasına izin verdiğiniz tüm veriler kaldırılacaktır. Buna işitme cihazınız ve aktivite verileriniz de dahildir.",
		"delete_account_header" : "{0} hesabını sil",
		"device_may_support_two_way_audio_message" : "To learn more about streaming capabilities for your specific device,",
		"device_may_support_two_way_audio_message_tap_here" : "tap here.",
		"download_app" : "{0} uygulamasını indirin",
		"email_input" : "E-posta adresini girin",
		"email_to_confirm_deletion_body" : "Ardından, {0} hesabınızın silinmesini onaylamanızı isteyen bir e-posta alacaksınız. Hesabınızı silmek için talimatları izleyin.",
		"header" : "Ben...",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "Your computer is not supported for streaming to our hearing aids.",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "However, you may experience limited performance due to your device's operating system (OS). To learn more about recommended devices,",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "My SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "No account information exists for the email address entered for {0}.",
		"not_recognized" : "Üzgünüz, cihazınız tanınmadı ve desteklenmiyor.",
		"not_tested" : "Cihazınız tam olarak test edilmedi. Bu arada, pek çok özellik aktarıma gerek kalmadan çalıştığı için uygulamayı indirebilirsiniz.",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "or",
		"os_updated_required" : "Cihazınız destekleniyor ancak bir işletim sistemi (OS) güncellemesi gerekiyor.",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "Üzgünüz, kişisel bilgisayarlar desteklenmemektedir.",
		"recommended_devices_learn_more_message" : "To learn more about recommended devices,",
		"sent_check_email" : "Check your email",
		"sent_confirmation" : "If an account exists for the address entered, an email has been sent.",
		"soundgear_amp" : "Amplifikatör",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "Cihazınız destekleniyor, ancak akış mevcut değil.",
		"supported" : "Cihazınız destekleniyor!",
		"supported_cannot_update_os" : "However, you may experience limited performance due to your device's operating system (OS).",
		"supported_two_way" : "Cihazınız desteklenir ve 2 Yönlü Ses ile eller serbest görüşmeler yapabilir!",
		"tap_here" : "buraya dokun",
		"test" : "Bu bir test",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "{0} hesabınızı silmek için e-posta adresinizi girin ve \"Devam Et\"i seçin.",
		"unable_to_confirm_phone_support" : "We are unable to confirm if your device is fully supported. You can download the app but may experience limited performance.",
		"wearing_hearing_aids" : "{0} işitme cihazları kullanıyorum"
	},
	"zh-cn" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "我是家庭成员、朋友或护理员",
		"aid_type_form_header" : "我戴着……",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "智能手机兼容性",
		"banner_computer_support" : "支持助听器的计算机。",
		"banner_device_compatibility" : "设备兼容性",
		"banner_download_page" : "Download app",
		"caregiver" : "家庭成员、朋友或护理员",
		"caregiver_afton" : "我是家庭成员、朋友或护理人员。",
		"compatibility_list" : "请 {0} 获取兼容性列表。",
		"compatibility_link_text_mac" : "适用 iPhone 连接的助听器列表",
		"compatibility_link_text_windows" : "检查您的 Windows 11 电脑是否支持蓝牙低功耗音频",
		"compatiblity_statement_pc" : "有关助听器的计算机支持，请参阅以下内容：",
		"continue_button" : "继续",
		"data_removed_body" : "您先前同意存储的所有数据都将被删除。这包括您的助听器和活动数据。",
		"delete_account_header" : "删除 {0} 帐户",
		"device_may_support_two_way_audio_message" : "了解您的设备的音频流功能的更多信息",
		"device_may_support_two_way_audio_message_tap_here" : "点击此处",
		"download_app" : "下载 {0} app",
		"email_input" : "输入电子邮件地址",
		"email_to_confirm_deletion_body" : "然后，您将收到一封电子邮件，要求您确认删除您的 {0} 帐户。按照说明删除您的帐户。",
		"header" : "我是…",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "您的计算机不支持音频流传输到我们的助听器。",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "但是，由于设备的操作系统（OS），您可能会遇到性能受限的问题。为了解更多关于推荐设备的信息，",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "我的 SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "为 {0} 输入的电子邮件地址不存在帐户信息。",
		"not_recognized" : "抱歉，您的设备无法识别且不被支持。",
		"not_tested" : "您的设备未完全测试。在此期间，您可以下载该 app，因为许多功能无需音频流传输即可工作。",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "或",
		"os_updated_required" : "您的设备受支持，但需要更新操作系统（OS）。",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "抱歉，不支持个人电脑。",
		"recommended_devices_learn_more_message" : "为了解更多关于推荐设备的信息，",
		"sent_check_email" : "请检查电子邮件",
		"sent_confirmation" : "如果输入的邮件地址已存在帐户，则表示已发送电子邮件。",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "您的设备受支持，但音频流不可用。",
		"supported" : "支持您的设备！",
		"supported_cannot_update_os" : "但是，由于设备的操作系统（OS）的原因，您可能会遇到性能受限的问题。",
		"supported_two_way" : "您的设备受支持，并且能够使用双向音频进行免提通话！",
		"tap_here" : "请点击此处",
		"test" : "这是一个测试",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "若要删除您的 {0} 帐户，请输入您的电子邮件地址，然后选择“继续”",
		"unable_to_confirm_phone_support" : "我们无法确认您的设备是否完全受支持。您可以下载该应用程序，但可能会遇到性能受限的问题。",
		"wearing_hearing_aids" : "佩戴 {0} 助听器"
	},
	"zh-hans" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "我是家庭成员、朋友或护理员",
		"aid_type_form_header" : "我戴着……",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "智能手机兼容性",
		"banner_computer_support" : "支持助听器的计算机。",
		"banner_device_compatibility" : "设备兼容性",
		"banner_download_page" : "Download app",
		"caregiver" : "家庭成员、朋友或护理员",
		"caregiver_afton" : "我是家庭成员、朋友或护理人员。",
		"compatibility_list" : "请 {0} 获取兼容性列表。",
		"compatibility_link_text_mac" : "适用 iPhone 连接的助听器列表",
		"compatibility_link_text_windows" : "检查您的 Windows 11 电脑是否支持蓝牙低功耗音频",
		"compatiblity_statement_pc" : "有关助听器的计算机支持，请参阅以下内容：",
		"continue_button" : "继续",
		"data_removed_body" : "您先前同意存储的所有数据都将被删除。这包括您的助听器和活动数据。",
		"delete_account_header" : "删除 {0} 帐户",
		"device_may_support_two_way_audio_message" : "了解您的设备的音频流功能的更多信息",
		"device_may_support_two_way_audio_message_tap_here" : "点击此处",
		"download_app" : "下载 {0} app",
		"email_input" : "输入电子邮件地址",
		"email_to_confirm_deletion_body" : "然后，您将收到一封电子邮件，要求您确认删除您的 {0} 帐户。按照说明删除您的帐户。",
		"header" : "我是…",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "您的计算机不支持音频流传输到我们的助听器。",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "但是，由于设备的操作系统（OS），您可能会遇到性能受限的问题。为了解更多关于推荐设备的信息，",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "我的 SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "为 {0} 输入的电子邮件地址不存在帐户信息。",
		"not_recognized" : "抱歉，您的设备无法识别且不被支持。",
		"not_tested" : "您的设备未完全测试。在此期间，您可以下载该 app，因为许多功能无需音频流传输即可工作。",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "或",
		"os_updated_required" : "您的设备受支持，但需要更新操作系统（OS）。",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "抱歉，不支持个人电脑。",
		"recommended_devices_learn_more_message" : "为了解更多关于推荐设备的信息，",
		"sent_check_email" : "请检查电子邮件",
		"sent_confirmation" : "如果输入的邮件地址已存在帐户，则表示已发送电子邮件。",
		"soundgear_amp" : "Amp",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "您的设备受支持，但音频流不可用。",
		"supported" : "支持您的设备！",
		"supported_cannot_update_os" : "但是，由于设备的操作系统（OS）的原因，您可能会遇到性能受限的问题。",
		"supported_two_way" : "您的设备受支持，并且能够使用双向音频进行免提通话！",
		"tap_here" : "请点击此处",
		"test" : "这是一个测试",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "若要删除您的 {0} 帐户，请输入您的电子邮件地址，然后选择“继续”",
		"unable_to_confirm_phone_support" : "我们无法确认您的设备是否完全受支持。您可以下载该应用程序，但可能会遇到性能受限的问题。",
		"wearing_hearing_aids" : "佩戴 {0} 助听器"
	},
	"zh-hant" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "我是家人, 朋友或照顧者",
		"aid_type_form_header" : "我戴著",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "智能手機相容性",
		"banner_computer_support" : "電腦可支援助聽器",
		"banner_device_compatibility" : "設備相容性",
		"banner_download_page" : "下載app",
		"caregiver" : "家庭成員、朋友或照護者",
		"caregiver_afton" : "我是家庭成員, 朋友, 或監護人",
		"compatibility_list" : "請{0}獲取相容列表。",
		"compatibility_link_text_mac" : "Made for iPhone 聽力設備列表",
		"compatibility_link_text_windows" : "檢查您的 Windows 11 電腦是否支援藍牙低功耗音頻",
		"compatiblity_statement_pc" : "助聽器的電腦支援請參考以下內容：",
		"continue_button" : "繼續",
		"data_removed_body" : "您先前儲存的資料將會被刪除. 包括您的助聽器及活動資料.",
		"delete_account_header" : "刪除 {0}帳號",
		"device_may_support_two_way_audio_message" : "要了解有關特定設備的串流媒體功能的更多信息，",
		"device_may_support_two_way_audio_message_tap_here" : "請點擊此處",
		"download_app" : "下載 {0}app",
		"email_input" : "請輸入電郵",
		"email_to_confirm_deletion_body" : "您會收到一封電郵, 要求確認刪除您的 {0}帳號. 請依照說明刪除您的帳號.",
		"header" : "我是....",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "你的電腦設備無法支援我們助聽器的串流功能",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KINDiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "但是，由於裝置作業系統 (OS) 的原因，您可能會遇到效能有限的情況。要了解有關推薦設備的更多信息，",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "我的SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "為 {0} 輸入的電子郵件地址不存在任何帳戶資訊。",
		"not_recognized" : "抱歉，您的設備無法識別且不被支持。",
		"not_tested" : "您的設備未完全測試。在此期間，您可以下載該 app，因為許多功能無需音頻流傳輸即可工作。",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "或",
		"os_updated_required" : "可支援您的設備，但需要更新操作系統（OS）。",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "抱歉，不支持個人電腦。",
		"recommended_devices_learn_more_message" : "欲了解更多建議設備,",
		"sent_check_email" : "請檢查電子郵件",
		"sent_confirmation" : "如果輸入的郵件地址已存在帳戶，則表示已傳送電子郵件。",
		"soundgear_amp" : "擴大器",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "可支援您的設備，但音頻串流不能使用。",
		"supported" : "您的設備可以使用！",
		"supported_cannot_update_os" : "因您的設備作業系統(OS)無法完整支援, 造成部分功能可能無法執行.",
		"supported_two_way" : "您的設備可以使用並能夠通過 2-Way Audio 進行免提通話！",
		"tap_here" : "請點擊這裡",
		"test" : "這是一個測試",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "要刪除您的 {0}帳號, 請輸入電郵並點選\"繼續\"",
		"unable_to_confirm_phone_support" : "無法確認能否完全支援您的設備. 您仍可下載APP使用, 但部分功能使用會有受限.",
		"wearing_hearing_aids" : "佩戴 {0}助聽器"
	},
	"zh-tw" : {
		"afflelou_incognito_edge_ai" : "Incognito Edge AI",
		"aid_type_form_caregiver" : "我是家人、朋友或照顧者",
		"aid_type_form_header" : "我佩戴...",
		"audibel_arc" : "Arc AI",
		"audibel_intrigue" : "Intrigue AI",
		"banner" : "智能手機兼容性",
		"banner_computer_support" : "助聽器的電腦支援。",
		"banner_device_compatibility" : "設備相容性",
		"banner_download_page" : "下載app",
		"caregiver" : "家庭成員、朋友或監護人",
		"caregiver_afton" : "我是家庭成員, 朋友, 或監護人",
		"compatibility_list" : "請 {0} 獲取兼容性列表。",
		"compatibility_link_text_mac" : "Made for iPhone 聽力設備列表",
		"compatibility_link_text_windows" : "檢查您的Windows 11是否支援藍芽低功耗音訊",
		"compatiblity_statement_pc" : "助聽器的電腦支援請參考以下內容:",
		"continue_button" : "繼續",
		"data_removed_body" : "先前儲存的所有數據資料將被刪除, 包括您的助聽器及活動數據資料.",
		"delete_account_header" : "刪除  {0} 帳號",
		"device_may_support_two_way_audio_message" : "要了解更多您設備的串流功能",
		"device_may_support_two_way_audio_message_tap_here" : "請點擊此處",
		"download_app" : "下載 {0} app",
		"email_input" : "輸入電郵",
		"email_to_confirm_deletion_body" : "您將收到一封要求確認要刪除您{0}帳號的電郵. 請依照說明進行帳號刪除",
		"header" : "我是",
		"hear_circle" : "Hear Circle",
		"hear_share" : "Hear Share",
		"incompatibility_statement_pc" : "您的設備無法支援我們助聽器的串流功能",
		"kind_varo" : "KINDvaro",
		"kind_vitalo" : "KINDvitalo",
		"kindilink_assist" : "KINDiLink Assist",
		"kindilink2" : "KindiLink2",
		"kindilink3" : "KINDiLink3",
		"limited_performance_phone_support" : "但是，由於裝置作業系統 (OS) 的原因，您可能會遇到效能有限的情況。要了解有關推薦設備的更多信息，",
		"my_audibel" : "My Audibel",
		"my_phantom" : "My Phantom",
		"my_sound_gear" : "我的SoundGear",
		"my_starkey" : "My Starkey",
		"no_account_exists_for_email" : "為 {0} 輸入的電子郵件地址不存在任何帳戶資訊。",
		"not_recognized" : "抱歉，無法辨識您的設備因此無法支援使用。",
		"not_tested" : "您的設備未完全測試。在此期間，您可以下載該 app，因為許多功能無需音頻流傳輸即可工作。",
		"nuear_nxg" : "NXG AI",
		"nuear_savant" : "Savant AI",
		"or" : "或者",
		"os_updated_required" : "可支援您的設備，但需要更新操作系統（OS）。",
		"ouiezen_SK_ED" : "OuïeZen SK ED",
		"pc_not_supported" : "抱歉，不支持個人電腦。",
		"recommended_devices_learn_more_message" : "欲了解更多建議設備,",
		"sent_check_email" : "請檢查電子郵件",
		"sent_confirmation" : "如果輸入的郵件地址已存在帳戶，則表示已傳送電子郵件。",
		"soundgear_amp" : "擴大器",
		"starkey_evolv" : "Evolv AI",
		"starkey_genesis" : "Genesis AI",
		"streaming_not_available" : "可支援您的設備，但音頻串流不可用。",
		"supported" : "可支援您的設備！",
		"supported_cannot_update_os" : "因您的設備作業系統(OS)無法完整支援, 造成部分功能可能無法執行.",
		"supported_two_way" : "您的設備可以使用並能夠通過 2-Way Audio 進行免提通話！",
		"tap_here" : "請點擊此處",
		"test" : "這是一個測試",
		"thrive" : "Thrive Hearing Control",
		"to_delete_account_body" : "要刪除您的{0}帳號, 請輸入您的電郵然後選擇\"繼續\"",
		"unable_to_confirm_phone_support" : "我們無法確認您的設備是否受到完全支援。您可以下載該應用程序，但某些功能可能會受到限制。",
		"wearing_hearing_aids" : "佩戴 {0} 助聽器"
	}

}